import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import CustomerEkycForm from "./indexForm";
import { Box, Dialog } from "@mui/material";
import {
  convertToAge,
  getRoute,
  getStorageItem,
  makeid,
  parseMessage,
  setStorageItem,
} from "../../../helpers/utils";
import { useHistory } from "react-router";
import { Utils } from "../../../constants/utils";
import { postWebService } from "../../../helpers/server";
import { validations } from "../../../messages/validation";
import { buildSystemErrorMessage } from "../../../helpers/buyflow";
import { buildWrapperTokenHeader } from "../../../helpers/lead";
import {
  buildGenerateOtpPayload,
  buildUpdateCustomerPayload,
  buildVerifyOtpPayload,
  parseEkycResponse,
} from "../../../helpers/ekyc";
import {
  SLUG_GENERATE_OTP,
  SLUG_LOGIN,
  SLUG_OTP,
  SLUG_SNACK_BAR,
} from "../../../constants/index";
import {
  FORM_FIELD_AADHAAR_NUMBER,
  FORM_FIELD_GENERATE_OTP,
  FORM_FIELD_MOBILE,
  FORM_FIELD_OTP,
  FORM_FIELD_PARTNER_ID,
  FORM_FIELD_STEP,
  FORM_FIELD_VERIFY_OTP,
} from "../../../constants/field";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function CustomerEkyc({ classes: { loaderBox } }) {
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState({
    [FORM_FIELD_AADHAAR_NUMBER]: "",
    [FORM_FIELD_OTP]: "",
  });
  const [errors, setErrors] = useState([]);
  const [form, setForm] = useState({
    [FORM_FIELD_AADHAAR_NUMBER]: "",
    [FORM_FIELD_OTP]: "",
    [FORM_FIELD_PARTNER_ID]: getStorageItem(FORM_FIELD_PARTNER_ID),
    [FORM_FIELD_GENERATE_OTP]: false,
    [FORM_FIELD_VERIFY_OTP]: false,
    isBlankEkycData: false,
    mismatch: null,
    step: SLUG_LOGIN,
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [modal, setModal] = useState({
    open: false,
    mismatch: false,
    snackbar: false,
  });
  const [touchFields, setTouchFields] = useState({
    [FORM_FIELD_AADHAAR_NUMBER]: false,
    [FORM_FIELD_OTP]: false,
  });
  const [backdrop, setBackdrop] = useState(false);

  useEffect(() => {
    async function wrapperToken() {
      try {
        const header = buildWrapperTokenHeader();
        const response = await postWebService("token.php", {}, header);

        setStorageItem("access-token", response.data.access_token);
        setTimeout(() => setIsLoaded(true), 100);
      } catch (error) {
        // console.log(error);
      }
    }

    wrapperToken();
  }, []);
  /* End: Wrapper Token API Call */

  useEffect(() => {
    setStorageItem(FORM_FIELD_GENERATE_OTP, false);
    setStorageItem(FORM_FIELD_VERIFY_OTP, false);
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    validateInputFormat(
      FORM_FIELD_AADHAAR_NUMBER,
      form[FORM_FIELD_AADHAAR_NUMBER]
    );
    setErrors([]);
  }, [form[FORM_FIELD_AADHAAR_NUMBER]]);

  const handleBack = () => navigateTo("product");

  const handleReinitiateJourney = () => navigateTo("product");

  const handleRetry = () => window.location.reload();

  const handleChange = (event) =>
    setFormState(event.target.name, event.target.value);

  const handleClose = (keyname = "open", flag = false) =>
    toggleModal(keyname, flag);

  const handleOnClose = (event, reason, modalKey) => {
    if (Utils.dialogOnCloseReasons.indexOf(reason) === -1) {
      handleClose(modalKey, false);
    }
  };

  const handleResendOtp = () => {
    setErrors([]);
    setForm({
      ...form,
      step: SLUG_LOGIN,
      otp: "",
    });
  };

  const navigateTo = (url = "payment") =>
    history.push({ pathname: getRoute(url) });

  const setStateVariables = (key, isValid, message) => {
    setFormState("hasError", !isValid);
    setErrorMessageState(key, message);
    setTouchFieldsState(key, true);
  };

  const setTouchFieldsState = (name, value) =>
    setTouchFields({ ...touchFields, [name]: value });

  const setErrorMessageState = (name, value) =>
    setErrorMessage({ ...errorMessage, [name]: value });

  const setFormState = (name, value) => setForm({ ...form, [name]: value });

  const toggleModal = (keyname = "open", flag = true) =>
    setModal({ ...modal, [keyname]: flag });

  const validateInputLength = (event) => {
    let elName = event.target.name;
    let elValue = event.target.value;

    if (
      event.target.name === FORM_FIELD_AADHAAR_NUMBER ||
      event.target.name === FORM_FIELD_OTP ||
      event.target.name === FORM_FIELD_MOBILE
    ) {
      var clean = elValue.replace(/[^0-9]+/g, "");
      event.target.value = clean;
    }

    if (elValue.length > Utils.limit.digits[elName]) {
      event.target.value = elValue.substring(0, Utils.limit.digits[elName]);
    }
  };

  const validateInputFormat = (fieldName, fieldValue) => {
    if (fieldValue) {
      let isValid = Utils.regex[fieldName].test(fieldValue);
      setStateVariables(
        fieldName,
        isValid,
        isValid ? "" : validations[fieldName].valid
      );
    } else if (touchFields[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  /* Start: Generate and Verify OTP Section */
  const cbError = ({ data: { error_msg } }) => {
    setIsFormSubmitted(false);
    setBackdrop(false);
    const message = parseMessage(error_msg);
    if (Array.isArray(message)) {
      setErrors(message);
    } else {
      let messageArray = [];
      messageArray.push(message);
      setErrors(messageArray);
    }
  };

  const cbSuccessGenerateOtp = ({
    accessKey = null,
    message = null,
    responseCode,
  }) => {
    setIsFormSubmitted(false);
    setBackdrop(false);
    if (responseCode === "AORes000") {
      setForm({
        ...form,
        accessKey,
        [SLUG_GENERATE_OTP]: true,
        [FORM_FIELD_STEP]: SLUG_OTP,
      });
      setStorageItem(SLUG_GENERATE_OTP, true);
      toggleModal(SLUG_SNACK_BAR, true);
    } else {
      setErrors(new Array(message));
      setIsFormSubmitted(false);
    }
  };

  const generateOtp = async () => {
    try {
      setErrors([]);
      setIsFormSubmitted(true);
      setBackdrop(true);
      const response = await postWebService(
        "adhar-otp.php",
        buildGenerateOtpPayload(form)
      );

      cbSuccessGenerateOtp(response.data);
    } catch (error) {
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : buildSystemErrorMessage()
      );
    }
  };

  const onSubmitGenerateOtp = (event) => {
    event.preventDefault();

    generateOtp();
  };

  const isAgeMismatched = ({ userDob }) => {
    return (
      Number(convertToAge(getStorageItem("dob"))) !==
      Number(convertToAge(userDob))
    );
  };

  const isGenderMismatch = ({ userGender }) => {
    return (
      getStorageItem("gender").toLocaleLowerCase() !==
      userGender.toLocaleLowerCase()
    );
  };

  const validateAgeAndGender = (customerDetails) => {
    let errorMessage = null,
      isValid = true;

    if (isAgeMismatched(customerDetails)) {
      errorMessage = "Age mismatch.";
      isValid = false;
    } else if (isGenderMismatch(customerDetails)) {
      errorMessage = "Gender mismatch.";
      isValid = false;
    }

    if (!isValid) {
      setFormState("mismatch", errorMessage);
      toggleModal("mismatch", true);
      setBackdrop(false);
    } else {
      validateCustomerPincode(customerDetails);
    }
  };

  const validateCustomerPincode = async (customerDetails) => {
    try {
      const response = await postWebService("validatepincode.php", {
        pincode: customerDetails.pincode,
      });

      if (response.data.code != 202) {
        setBackdrop(false);
        setStorageItem(
          "journeyCloseReason",
          "Journey terminated due to Pincode vadilation."
        );
        navigateTo("terminated");
      } else {
        validateIIBScore(customerDetails);
      }
    } catch (error) {
      cbError(error);
    }
  };

  const validateIIBScore = async (customerDetails) => {
    try {
      const response = await postWebService("checkiibstatus.php", {
        oid: Number(getStorageItem("oid")),
      });

      let dataSlice = response.data.data.slice(9);
      dataSlice = dataSlice.slice(0, -8);
      const data = JSON.parse(atob(dataSlice));
      if (data.code == 200) {
        var status = data.data.status ?? null;
        var reason =
          data.data.reason ?? "Journey terminated due IIB vadilation.";
        if (status === false) {
          setBackdrop(false);
          setStorageItem("journeyCloseReason", reason);
          navigateTo("terminated");
        } else {
          updateOrderDetails(customerDetails);
        }
      }
    } catch (error) {
      cbError(error);
    }
  };

  const updateOrderDetails = async (customerDetails) => {
    try {
      const response = await postWebService("update-order.php", {
        oid: Number(getStorageItem("oid")),
        EKYCresponseID: getStorageItem("ekycResponseId"),
        status: "EKYCINITIATED",
      });

      if (response.data.code === 201) {
        setBackdrop(false);
        navigateTo("customer");
      }
    } catch (error) {
      cbError(error);
    }
  };

  const updateCustomerDetails = async (customerDetails) => {
    try {
      const response = await postWebService(
        "update-customer.php",
        buildUpdateCustomerPayload(customerDetails)
      );

      if (response.data.code === 200) {
        validateAgeAndGender(customerDetails);
      }
    } catch (error) {
      cbError(error);
    }
  };

  const onSuccessVerifyOtp = (encodedData, checksum) => {
    let dataSlice = encodedData.data.slice(9);
    dataSlice = dataSlice.slice(0, -8);

    const data = JSON.parse(atob(dataSlice));
    if (data.responseCode === "AFRes000" && data.checksum == checksum) {
      const customerDetails = parseEkycResponse(data);
      setStorageItem("ekycResponseId", data.responseID);
      setForm({
        ...form,
        ekycResponseId: data.responseID,
        isBlankEkycData:
          !customerDetails.userName ||
          !customerDetails.userDob ||
          !customerDetails.userGender,
      });

      updateCustomerDetails(customerDetails);
    } else {
      setErrors(new Array(data.message));
      setIsFormSubmitted(false);
      setBackdrop(false);
      setForm({
        ...form,
        step: SLUG_LOGIN,
      });
    }
  };

  const onSubmitVerifyOtp = async (event) => {
    try {
      event.preventDefault();
      setErrors([]);
      setIsFormSubmitted(true);
      setBackdrop(true);
      const checksum = makeid();
      const response = await postWebService(
        "adhar-otp-verification.php",
        buildVerifyOtpPayload(form, checksum)
      );
      onSuccessVerifyOtp(response.data, checksum);
    } catch (error) {
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : buildSystemErrorMessage()
      );
    }
  };
  /* End: Generate and Verify OTP Section */

  return isLoaded ? (
    <CustomerEkycForm
      backdrop={backdrop}
      errors={errors}
      errorMessage={errorMessage}
      form={form}
      handleBack={handleBack}
      handleChange={handleChange}
      handleClose={handleClose}
      handleOnClose={handleOnClose}
      handleReinitiateJourney={handleReinitiateJourney}
      handleResendOtp={handleResendOtp}
      handleRetry={handleRetry}
      isFormSubmitted={isFormSubmitted}
      modal={modal}
      onSubmitGenerateOtp={onSubmitGenerateOtp}
      onSubmitVerifyOtp={onSubmitVerifyOtp}
      setFormState={setFormState}
      validateInputLength={validateInputLength}
    />
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(CustomerEkyc);
